<template>
    <f7-page color-theme="teal" name="todo" ptr @ptr:refresh="loadMore">
        <f7-navbar title="Todo">

            <f7-nav-right>
                <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="right"></f7-link>
            </f7-nav-right>
        </f7-navbar>

        <f7-card class='update-success bg-color-success' v-show="showAlert"
        :content="'Succesfully added custom event for ' + customItemDate"
        ></f7-card>

        <f7-block-title>{{titleLabel}} for {{ todo.date }}</f7-block-title>
        <f7-list>
            <!--<f7-block-title>Tasks for {{ todaydates }}</f7-block-title>-->
            <f7-list-item
                    v-for="(group,id) in todo.groups" :key="id"
                    :title="group.name" :badge="group.items_open" badge-color="green"
                    :link="`/todo/${id}`"
            ></f7-list-item>
        </f7-list>

       <!--<f7-fab position="right-bottom" slot="fixed" color="blue" link="/todo/add">
            <f7-icon ios="f7:add" md="material:add"></f7-icon>
        </f7-fab>-->
    </f7-page>
</template>

<script>
    export default {
        data() {
            return {
                showAlert: false,
                showAlertSaved: false,
                todos:[],
                tokenValue: {},
                token: localStorage.getItem('token'),
                user: {},
                titleLabel: '',
                customItemDate: ''
            }
        },
        watch: {
            isAuth(val) {
                if(val==false) {
                    this.$f7router.navigate('/login');
                }
            },
            isUpdated(val) {
                var $$ = this.Dom7;
                if (val) {
                    $$('.update-success').show();
                    this.customItemDate = new Date(val.date).toISOString().substr(0,10);
                    setTimeout(function(){
                        $$('.update-success').hide();
                    }, 5000);
                }
            }
        },
        computed:{
            isAuth() {
                return this.$store.getters['admin/isAuth']
            },
            todo() {
                return this.$store.getters['todo/getTodo']
            },
            isUpdated() {
                return this.$store.getters['todo/getStateUpdated']
            },
            todaydate() {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0!
                var yyyy = today.getFullYear();

                if (dd < 10) {
                    dd = '0' + dd;
                }

                if (mm < 10) {
                    mm = '0' + mm;
                }

                today = dd + '-' + mm + '-' + yyyy;
                return today;
            }
        },
        methods: {
            getTodo() {
                this.tokenValue = this.$parseJWT(this.token);
                this.$store.dispatch('todo/getTodo',this.editFilter());
            },
            loadMore(event, done) {
                this.getTodo();
                done();
            },
            editFilter() {
                return JSON.parse(localStorage.getItem('edit'));
            }
        },
        created() {
            this.titleLabel = (this.editFilter() == null) 
                ? 'Tasks ' 
                : 'Edit events ';
            this.interval = setInterval(() => this.getTodo(), 30000); //every 30 secs
            this.getTodo();
        }
    };
</script>

<style>
.bg-color-success {
    color: #3c763d;
    background-color: #dff0d8 !important;
    border-color: #d6e9c6 !important;
}
</style>